import { Instagram, Facebook, Linkedin, Youtube, Twitter, Globe, MessageCircle, AtSign } from "lucide-react";

// Provider metadata — icon is chosen automatically (no custom SVG/HTML permitted).
export const SOCIAL_PROVIDERS = [
  { id: "instagram", label: "Instagram", Icon: Instagram, domains: ["instagram.com"] },
  { id: "facebook", label: "Facebook", Icon: Facebook, domains: ["facebook.com", "fb.com", "fb.me"] },
  { id: "linkedin", label: "LinkedIn", Icon: Linkedin, domains: ["linkedin.com"] },
  { id: "youtube", label: "YouTube", Icon: Youtube, domains: ["youtube.com", "youtu.be"] },
  { id: "x", label: "X / Twitter", Icon: Twitter, domains: ["x.com", "twitter.com"] },
  { id: "pinterest", label: "Pinterest", Icon: Globe, domains: ["pinterest.com", "pin.it"] },
  { id: "threads", label: "Threads", Icon: AtSign, domains: ["threads.net"] },
  { id: "whatsapp", label: "WhatsApp", Icon: MessageCircle, domains: ["wa.me", "whatsapp.com"] },
  { id: "other", label: "Website / Other", Icon: Globe, domains: null },
];

export const providerMeta = (id) => SOCIAL_PROVIDERS.find((p) => p.id === id) || SOCIAL_PROVIDERS[SOCIAL_PROVIDERS.length - 1];

const isSafeHttps = (url) => {
  try {
    const u = new URL(String(url).trim());
    return u.protocol === "https:";
  } catch { return false; }
};

export const matchesProviderDomain = (id, url) => {
  const meta = providerMeta(id);
  if (!meta.domains) return isSafeHttps(url);
  try {
    let host = new URL(url).hostname.toLowerCase();
    if (host.startsWith("www.")) host = host.slice(4);
    return meta.domains.some((d) => host === d || host.endsWith("." + d));
  } catch { return false; }
};

// Returns only active, safe, valid links sorted by display order (single source of truth: config.social_links).
export function activeSocialLinks(config) {
  const links = (config && config.social_links) || [];
  return links
    .filter((l) => l && l.active !== false && isSafeHttps(l.url) && matchesProviderDomain(l.provider, l.url))
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}
